<template>
  <q-chip
    :clickable="!!featureName"
    dense
    icon="mdi-tools"
    label="Beta"
    color="orange-3"
    size="12px"
    class="text-bold"
    v-bind="$attrs"
    @click="open"
    @click.stop
  />
</template>

<script>
import { Dialog } from 'quasar'
import BetaPluginDialog from 'components/partials/dialogs/BetaPluginDialog.vue'

export default {
  inheritAttrs: false,
  props: {
    featureName: {
      type: String,
      default: null
    }
  },
  methods: {
    open () {
      if (!this.featureName) {
        return
      }

      Dialog.create({
        component: BetaPluginDialog,
        componentProps: {
          featureName: this.featureName
        }
      })
    }
  }
}
</script>
